import React, { createContext, useContext, useState, useCallback } from "react";

const FeaturedSearchContext = createContext(null);

export function FeaturedSearchProvider({ children }) {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  // NEWEST: every piece sells once, so an order by popularity only ever
  // ranked what was already gone. (Was "default", Most Popular.)
  const [sortOption, setSortOption] = useState("newest");

  const toggleSearch = useCallback(() => {
    setSearchOpen((prev) => {
      if (prev) setSearchQuery("");
      return !prev;
    });
  }, []);

  const closeSearch = useCallback(() => {
    setSearchOpen(false);
    setSearchQuery("");
  }, []);

  const value = {
    searchOpen,
    setSearchOpen,
    searchQuery,
    setSearchQuery,
    sortOption,
    setSortOption,
    toggleSearch,
    closeSearch,
  };

  return <FeaturedSearchContext.Provider value={value}>{children}</FeaturedSearchContext.Provider>;
}

export function useFeaturedSearch() {
  return useContext(FeaturedSearchContext);
}
